import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import TuiSelect from '../Select';
import TuiOption from '../Option';


export default /*#__PURE__*/_defineComponent({
  __name: 'DatepickerH5',
  props: {
    value: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: string | Date;
};




const currentValue = ref();
watch(
  () => props.value,
  val => {
    if (!val) return;
    currentValue.value = new Date(val).getTime();
  },
  { immediate: true }
);
watch(currentValue, val => emit('input', new Date(val)), { immediate: true });

function generateYearDates(year: number) {
  const startDate = new Date(year, 0, 1);
  const endDate = new Date(year, 11, 31);
  const dates = [];

  const currentDate = startDate;
  while (currentDate <= endDate) {
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();

    dates.push(
      `${year}/${month < 10 ? `0${month}` : month}/${day < 10 ? `0${day}` : day}`
    );
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}

const yearDates = generateYearDates(new Date().getFullYear()).map(item => ({
  label: item,
  value: new Date(item).getTime(),
}));

return { __sfc: true,props, emit, currentValue, generateYearDates, yearDates, TuiSelect, TuiOption }
}

})